/* eslint-disable import/no-extraneous-dependencies */
import {ToastContainer} from 'react-toastify';

import Routes from './routes/routes';
import ErrorBoundary from 'ErrorBoundary';
import FallBackComponent from 'components/FallBackComponent';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const TIMEOUT = Number(process.env.REACT_APP_TIMEOUT_TOAST);

const App = () => (
	<ErrorBoundary fallBack={<FallBackComponent />}>
		<ToastContainer
			position="bottom-center"
			autoClose={TIMEOUT}
			hideProgressBar={false}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
		/>
		<Routes />
	</ErrorBoundary>
);

export default App;
